import { RESEND_OTP, RESEND_OTP_SUCCESS, RESEND_OTP_ERROR, RESEND_OTP_EMPTY } from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ResendOTP = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_OTP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case RESEND_OTP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case RESEND_OTP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case RESEND_OTP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ResendOTP;
